import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import apiSafibc from "../../../axios/axios";
import { useLoginStore } from '../../../store/zustend';
import Swal from "sweetalert2";


const RegistrarCliente = () => {

    const [datos, setDatos] = useState({})
    const { loginStore } = useLoginStore()
    const [catLugarPago, setCatLugarPago] = useState([])
    const [lugarPago, setLugarPago] = useState('')
    const [spRA, setSpRA] = useState(false)

    const [ine, setIne] = useState({
        frente: null,
        reverso: null
    });

    const [preview, setPreview] = useState({
        frente: null,
        reverso: null
    });


    const obtenerCatalogo = () => {


        const obtener = async () => {

            try {

                const obteniendo = await apiSafibc.get('/registrar-cliente/catalogo', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setCatLugarPago(obteniendo.data.lugarPagos)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        obtener()


    }


    useEffect(() => {
        obtenerCatalogo()
    }, [])

    const leerDatos = (e) => {

        setDatos({
            ...datos,
            [e.target.name]: typeof e.target.value === 'string' ? e.target.value.toUpperCase() : e.target.value
        })
    }

    const leerINE = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (!file) return;

        // validar tipo
        if (!file.type.startsWith('image/')) {
            toast.error('El archivo debe ser una imagen', toast_config);
            return;
        }

        // validar tamaño (5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error('La imagen no debe exceder 5MB', toast_config);
            return;
        }

        setIne(prev => ({
            ...prev,
            [name]: file
        }));

        // preview
        setPreview(prev => ({
            ...prev,
            [name]: URL.createObjectURL(file)
        }));
    };

    const validarINEFront = () => {
        if (!ine.frente || !ine.reverso) {
            toast.error('Debes subir el frente y reverso de la INE', toast_config);
            return false;
        }

        if (ine.frente.name === ine.reverso.name) {
            toast.error('Las imágenes de frente y reverso deben ser distintas', toast_config);
            return false;
        }

        return true;
    };

    const validarDatosFrom = () => {
        let key = ''
        console.log(datos)
        if(!datos.nombre) key = 'Nombre'
        if(!datos.paterno)  key = 'Apellido Paterno'
        if(!lugarPago)  key = 'Lugar de Pago'
        if(!datos.cel)  key = 'Celular'
        if(!datos.direccion)  key = 'direccion'

        
        return key

    }

    const enviarFormulario = async () => {

        if (!validarINEFront()) return;
        const validacionDatos = validarDatosFrom()
        if(validacionDatos){
            return toast.error(`Es necesario agregar ${validacionDatos}!`, toast_config)
        } 
        setSpRA(true)
        datos.id_lugar_pago = lugarPago
        const formData = new FormData();
    
        Object.entries(datos).forEach(([key, value]) => {
            formData.append(key, value);
        });

        formData.append('documento_frente', ine.frente);
        formData.append('documento_reverso', ine.reverso);
    
        // Aquí luego irá al backend

        const mandarForm = async() => {
            try {

                const crearCliente = await apiSafibc.post('/registrar-cliente/registrar',formData, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': '*/*',
                    }
                })

                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena',
                    text: crearCliente.data.mensaje
                }).then((result) => {
                    window.location.href = '/registrar-cliente' 
                })

                setSpRA(false)
                
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al registrar cliente, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setSpRA(false)
            }
        }

        mandarForm()
        

    };


    return (
        <div className="container pt-5 animation">
            <div className='row d-flex justify-content-center'>
                <div className='col-md-6'>
                    <div className='card shadow'>
                        <div className='card-body'>
                            <h3>Registrar Cliente</h3>
                            <hr />

                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <TextField onChange={leerDatos} name='nombre' className="mb-2" label="Nombre(s)" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <TextField onChange={leerDatos} name='paterno' className="mb-2" label="Paterno" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <TextField onChange={leerDatos} name='materno' className="mb-2" label="Materno" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className='col-md-4 mb-3'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Lugar de Pago</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={lugarPago}
                                            onChange={(e) => setLugarPago(e.target.value)}
                                            label="Lugar de Pago"
                                        >
                                            {catLugarPago && catLugarPago.map(lp => (
                                                <MenuItem value={lp.id_lugar_pago} key={lp.id_lugar_pago}>{lp.lugar_pago}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                
                                <div className='col-md-6'>
                                    <TextField onChange={leerDatos} inputProps={{ maxLength: 10 }} name='cel' className="mb-2" label="Celular" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className="col-md-8 mb-3">
                                    <TextField onChange={leerDatos} name='direccion' className="mb-2" label="Direccion" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <TextField
                                        type="file"
                                        name="frente"
                                        variant="standard"
                                        label="INE Frente"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ accept: "image/*" }}
                                        onChange={leerINE}
                                        fullWidth
                                    />
                                    {preview.frente && (
                                        <img src={preview.frente} alt="INE Frente" className="img-fluid mt-2 rounded" width={150}/>
                                    )}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <TextField
                                        type="file"
                                        name="reverso"
                                        variant="standard"
                                        label="INE Reverso"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ accept: "image/*" }}
                                        onChange={leerINE}
                                        fullWidth
                                    />
                                    {preview.reverso && (
                                        <img src={preview.reverso} alt="INE Reverso" className="img-fluid mt-2 rounded" width={150} />
                                    )}
                                </div>

                                <div className='col-md-12 d-flex justify-content-center'>
                                    <Button disabled={spRA} onClick={enviarFormulario} size="small" className="mt-3" variant="contained" style={{ 'width': '75%' }}>
                                        Guardar
                                        {spRA && <div className="spinner-border spinner-border-sm" role="status" id='spisLoad'>
                                            <span className="sr-only"></span>
                                        </div>}
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )

}

export default RegistrarCliente